export const enum FontAwesomeIconTypeEnum {
  regular = 'regular',
  solid = 'solid',
}
